// Talks to the API. VITE_API_URL set → the public endpoints; unset (local dev) → categories come from the built-in
// list and the submit is simulated and logged, so the page can be tried without a server.
import { CATEGORIES, type Locale, type toPayload } from './application';

export type Payload = ReturnType<typeof toPayload>;
export interface SubmitResult {
  reference: string;
  simulated: boolean;
}
export interface CategoryOption {
  id: string;
  name: Record<Locale, string>;
}

const apiUrl = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '');

/** "YK-" and the last 6 hex digits of the application id: short enough to read out on a call. */
export const referenceFor = (id: string) => `YK-${id.replace(/-/g, '').slice(-6).toUpperCase()}`;

export async function loadCategories(): Promise<CategoryOption[]> {
  if (!apiUrl) return CATEGORIES.map((c) => ({ id: c.key, name: { ar: c.ar, en: c.en } }));
  const res = await fetch(`${apiUrl}/v1/public/categories`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const body = (await res.json()) as { items: { id: string; nameI18n: { ar?: string; en?: string }; sortOrder: number }[] };
  return [...body.items]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((c) => ({ id: c.id, name: { ar: c.nameI18n.ar || c.nameI18n.en || '', en: c.nameI18n.en || c.nameI18n.ar || '' } }));
}

export async function submitApplication(payload: Payload): Promise<SubmitResult> {
  if (!apiUrl) {
    await new Promise((r) => setTimeout(r, 700));
    console.info('[join] simulated submit', payload);
    return { reference: referenceFor(crypto.randomUUID()), simulated: true };
  }
  const res = await fetch(`${apiUrl}/v1/public/partner-applications`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (res.status === 429) throw new Error('rate_limited');
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const body = (await res.json()) as { id: string };
  return { reference: referenceFor(body.id), simulated: false };
}
